var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"tab button group"}},_vm._l((_vm.tabs),function(tab,i){return _c('button',{key:i,class:tab.tabCss,on:{"click":function($event){return _vm.btnChange(tab.tabNo)}}},[_vm._v("\n    "+_vm._s(tab.tabName)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }